module.exports = __webpack_public_path__ + "static/img/selfcheck_list_img.326457be.png";